// elements/theming/coloring-system.ts
import { LocalStorageReactive } from "@adornis/base/rxjs-extension/reactives/client/local-storage";
import { BehaviorSubject } from "rxjs";
var theme = LocalStorageReactive ? new LocalStorageReactive("__adornis_theme", "light") : new BehaviorSubject("light");
var createCssVarEntriesArray = (theme2, baseString = "--color") => {
  let keyValueArr = [];
  Object.keys(theme2).forEach((themeKey) => {
    if (typeof theme2[themeKey] === "object")
      keyValueArr = keyValueArr.concat(
        createCssVarEntriesArray(theme2[themeKey], baseString + "-" + themeKey.toLowerCase())
      );
    else
      keyValueArr.push([baseString + "-" + themeKey.toLowerCase(), theme2[themeKey]]);
  });
  return keyValueArr;
};
export {
  createCssVarEntriesArray,
  theme
};
